export const MSG_FIELDS_OPTIONS = {
	APPSCOPE: 'AppScope',
	ACUITY: 'Acuity',
	CLASSVALUATION: 'Class',
	CLASSORDERENTRY:'ClassOrderEntry',
	CMPACUITY: 'CMPAcuity'
};

export const MSG_FIELDS_VALUE = {
	APPSCOPECHECK: {
		SCOPE: 'Select the job that the incoming order need to match',
		ACUITY: 'Select the product for the new order'
	},
	ACUITYCHECK: {
		SCOPE: 'Select the job name for the new order',
		ACUITY: 'Select the product that the incoming order needs to match'
	},
	DEFAULT: {
		SCOPE: 'Select the job for the new order',
		ACUITY: 'Select the product name for the new order'
	}
};

export const GSE_PREFERENCE = [
	{
		id: 'None',
		name: 'None'
	},
	{
		id: 'FREDDIE',
		name: 'Freddie Mac'
	},
	{
		id: 'FNMA',
		name: 'Fanni Mae'
	}
];
export const ORIGIN_LIST = [
	{
		id: 'AppScope',
		name: 'AppScope'
	},
	{
		id: 'Class',
		name: 'ClassValuation'
	},
	{
		id: 'Acuity',
		name: 'Acuity'
	},
	{
		id: 'ClassOrderEntry',
		name: 'ClassOrderEntry'
	},
	{
		id: 'CMPAcuity',
		name: 'CMPAcuity'
	}
];

export const LINE_BUSINESS_LIST = [
	{
		id: 'Traditional',
		name: 'Traditional'
	},
	{
		id: 'Innovation',
		name: 'Innovation'
	},
	{
		id: 'Alternative',
		name: 'Alternative'
	}
];

export const ACUITY_TYPES_ORIGIN_LIST = [
	{
		id: 'acuity',
		name: 'Acuity'
	},
	{
		id: 'cmpacuity',
		name: 'Cmp Acuity'
	}
]

export class ClassValuationIntegration {
	integrationName?: string;
	integrationText?: string;
	isDefaultProduct?: boolean;
	productList?: Array<any> = [];
	isFhaProduct?: boolean;
	placeHolder?: string;
	defaultFhaNumber?: string;
	isEnabled?: boolean;
	optionSelected?: Array<any> = [];
	productId?: string;
	productName?: string;
	isOrderIncomeStatement?: boolean;
	isOrderRentSchedule?: boolean;
};

export const CREATION_TRIGGER = [
	{
		id: 'IncomingOrder',
		name: 'Incoming Provider Order'
	},
	{
		id: 'StatusChanged',
		name: 'Milestone Order Changes'
	}
];

export const SCOPE_ORDER_UPDATE_DOCUMENTS = 'SCOPE_ORDER_UPDATE_DOCUMENTS';
